(function () {
  function init(root) {
    if (!root || root.dataset.inited === "1") return;
    root.dataset.inited = "1";

    const items = Array.from(root.querySelectorAll("[data-faq-item]"));
    const buttons = Array.from(root.querySelectorAll("[data-faq-btn]"));

    function closeAll() {
      items.forEach((it) => {
        const btn = it.querySelector("[data-faq-btn]");
        const panel = it.querySelector("[data-faq-panel]");
        const plus = it.querySelector(".faq-plus");
        if (!btn || !panel) return;

        it.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
        panel.hidden = true;
        if (plus) plus.textContent = "+";
      });
    }

    function openItem(item) {
      const btn = item.querySelector("[data-faq-btn]");
      const panel = item.querySelector("[data-faq-panel]");
      const plus = item.querySelector(".faq-plus");
      if (!btn || !panel) return;

      item.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
      panel.hidden = false;
      if (plus) plus.textContent = "–";
    }

    // First open always
    closeAll();
    // if (items[0]) openItem(items[0]);

    buttons.forEach((btn) => {
  btn.addEventListener("click", () => {
    const item = btn.closest("[data-faq-item]");
    if (!item) return;

    const isOpen = item.classList.contains("is-open");

    closeAll();
    if (!isOpen) openItem(item); // open only if it was closed
  });
});

  }

  function scan() {
    document.querySelectorAll("[data-faq-acc]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", scan);
  document.addEventListener("shopify:section:load", scan);
})();
